import React, { useState, useEffect } from "react";
import { Card, Grid } from "@material-ui/core";
import { CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import "./ViewDepartment.css";
import img1 from "../../assets/ivy_logo.png";
import Button from "../../Components/Button";
import { Link, useParams } from "react-router-dom";
import {
  Progress,
  Modal,
  ModalHeader,
  ModalFooter,
  Form,
  ModalBody,
} from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ChatBox, ReceiverMessage, SenderMessage } from "mui-chat-box";
import { BASE_URL } from "../../variables/api";
import SunEditor from "../../Components/SunEditor/SunEditor";
import SunEditor1 from "../../Components/SunEditor copy/SunEditor";
import { Translate } from "src/utils/Translate";
interface ITicketData {
  subject: string;
  description: string;
  department: string;
  status: string;
  displayname: string;
  username: string;
  attachments: Array<any>;
}
interface ICommentData {
  ticket_id: string;
  content: string;
}

function ViewDepartmentTicket(props: any) {
  const { id } = useParams<{ id?: string }>();
  const [ticketData, setTicketData] = useState<ITicketData>({
    subject: "",
    description: "",
    department: "",
    status: "",
    displayname: "",
    username: "",
    attachments: [],
  });
  const [commentData, setCommentData] = useState<ICommentData>({
    ticket_id: id ?? "",
    content: "",
  });
  const navigate = useNavigate();
  const [comments, setComments] = useState([]);
  const [modal, setModal] = useState(false);
  const [role, setRole] = useState("");
  const [show, setShow] = useState(false);
  const [description, setDescription] = useState("");
  const [progress, setProgress] = useState("0");
  const [p, setP] = useState(false);
  const t = new Translate();
  const handleAddOpenFile = () => {
    setShow(false);
    setDescription("");
    setCommentData((prevstate: any) => ({ ...prevstate, content: "" }));
    setModal(true);
  };

  const handleChange = async (selectedOption: any) => {
    setCommentData((prevstate: any) => ({
      ...prevstate,
      content: selectedOption,
    }));
  };
  const handleChangeStatus = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTicketData((prevstate: any) => ({ ...prevstate, status: value }));
    Swal.fire({
      title: "Are you Sure you want to Change  this ticket Status ?",
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: `Cancel`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      Swal.fire({
        title: "Loading.......",
        showDenyButton: false,
        showConfirmButton: false,
      });
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/tickets/updateticketstatus.php`, {
            id: id,
            status: value,
          })
          .then((res: any) => {
            props.status?.map((S: any) => {
              if (S.id === value) {
                setProgress(S.progress);
              }
              Swal.fire("Status Updated Successfully", "", "success");
            });
          });
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const handleChangeDepartment = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTicketData((prevstate: any) => ({ ...prevstate, department: value }));
    Swal.fire({
      title: t.translate("Are you Sure you want to Redirect this ticket ?"),
      showDenyButton: true,
      confirmButtonText: t.translate("Confirm"),
      denyButtonText: t.translate(`Cancel`),
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      Swal.fire({
        title: "Loading.......",
        showDenyButton: false,
        showConfirmButton: false,
      });
      if (result.isConfirmed) {
        axios
          .post(`${BASE_URL}/tickets/redirectticketdepartment.php`, {
            id: id,
            department: value,
          })
          .then(() => {
            Swal.fire("Saved!", "", "success");
          });
      } else if (result.isDenied) {
        Swal.fire(t.translate("Changes are not saved"), "", "info");
      }
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    Swal.showLoading();
    axios
      .post(`${BASE_URL}/tickets/addcomment.php`, commentData)
      .then((res: any) => {
        let data = res.data.data;
        // setComments((prevstate:any)=>({...prevstate, data }));
        setP(!p);
      })
      .catch((e) => {
        let ee = e as any;
        Swal.fire(
          ee?.response?.data.msg ||
            t.translate("Failed to Connect Please refresh"),
          "",
          "error"
        );
      })
      .finally(() => {
        Swal.fire(t.translate("Comment Added Successfully"), "", "success");
        setModal(false);
      });
    // setAttachments((prevState: any) => [...prevState, res.data.data]);
  };
  useEffect(() => {
    axios
      .post(`${BASE_URL}/tickets/getticket.php`, { id: id })
      .then((res: any) => {
        setTicketData(res.data.data.ticket);
        setComments(res.data.data.comments);
        setProgress(res.data.data.status.progress);
        setTicketData((prevstate) => ({
          ...prevstate,
          attachments: res.data.data.attachments,
        }));
      });
  }, [p]);
  const sectionContent = (html: any) => {
    return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
  };
  return (
    <div>
      <Link
        style={{ marginTop: "2%" }}
        to="/"
        className="btn btn-secondary mb-3"
      >
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
      <Card>
        <p className="p" style={{ marginTop: "2%" }}>
          {`${t.translate("View Ticket No.")} ${id}`}
        </p>
        <CardBody md={12} sm={12} xs={12}>
          <div style={{ border: "3px solid", borderColor: "#3278bd" }}>
            <Grid
              style={{ margin: "20px", textAlign: "center" }}
              item
              md={12}
              sm={12}
              xs={12}
            >
              <img style={{ maxWidth: "200px" }} src={img1} alt="ivylogo" />
            </Grid>
            <Grid style={{ margin: "5%", alignContent: "center" }} container>
              <Grid style={{ margin: "2%" }} item md={3} sm={3} xs={11}>
                <label>{t.translate("Subject")}</label>
                <Input disabled type="text" value={ticketData.subject}></Input>
              </Grid>
              <Grid style={{ margin: "2%" }} item md={3} sm={3} xs={11}>
                <label>{t.translate("Ticket Owner")}</label>
                <Input
                  disabled
                  type="text"
                  value={
                    ticketData.displayname
                      ? ticketData.displayname
                      : ticketData.username
                  }
                ></Input>
              </Grid>
              <Grid style={{ margin: "2%" }} item md={3} sm={3} xs={11}>
                <label>{t.translate("Department")}</label>
                {props.departmentId.search(ticketData.department) === -1 ? (
                  <Input
                    disabled
                    required
                    type="select"
                    className="form-select"
                    value={ticketData.department}
                    name="department"
                    onChange={handleChangeDepartment}
                  >
                    <option value="" disabled>
                      {t.translate("Select Department")}
                    </option>
                    {props.departments?.map((d: any) => (
                      <option key={d.id} value={d.id}>
                        {d.department}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <Input
                    required
                    type="select"
                    className="form-select"
                    value={ticketData.department}
                    name="department"
                    onChange={handleChangeDepartment}
                  >
                    <option value="" disabled>
                      {t.translate("Select Department")}
                    </option>
                    {props.departments?.map((d: any) => (
                      <option key={d.id} value={d.id}>
                        {d.department}
                      </option>
                    ))}
                  </Input>
                )}
              </Grid>
              <Grid style={{ margin: "2%" }} item md={11} sm={11} xs={11}>
                <label>{t.translate("Description")}</label>

                <textarea
                  disabled
                  value={ticketData.description}
                  style={{ width: "100%" }}
                ></textarea>
              </Grid>
              <Grid style={{ margin: "2%" }} item md={11} sm={11} xs={11}>
                <label>{t.translate("Status")}</label>
                {props.departmentId.search(ticketData.department) === -1 ? (
                  <Input
                    disabled
                    required
                    type="select"
                    className="form-select"
                    value={ticketData.status}
                    name="status"
                    onChange={handleChangeStatus}
                  >
                    <option value="" disabled>
                      {t.translate("Select Status")}
                    </option>
                    {props.status?.map((d: any) => (
                      <option key={d.id} value={d.id}>
                        {d.status}
                      </option>
                    ))}
                  </Input>
                ) : (
                  <Input
                    required
                    type="select"
                    className="form-select"
                    value={ticketData.status}
                    name="status"
                    onChange={handleChangeStatus}
                  >
                    <option value="" disabled>
                      {t.translate("Select Status")}
                    </option>
                    {props.status?.map((d: any) => (
                      <option key={d.id} value={d.id}>
                        {d.status}
                      </option>
                    ))}
                  </Input>
                )}
              </Grid>
              <Grid style={{ margin: "2%" }} item md={11} sm={11} xs={11}>
                <label>{t.translate("Progress Status")} : </label>
                <Progress multi style={{ width: "100%", marginLeft: "10px" }}>
                  <Progress
                    className="progress-bar"
                    color="success"
                    style={{ width: `${progress}%` }}
                  />
                </Progress>
              </Grid>
            </Grid>
          </div>
          <div style={{ marginTop: "2%" }} className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr style={{ borderBottom: "1px solid" }}>
                  <th style={{ textAlign: "center" }}>{t.translate("ID")}</th>
                  <th style={{ textAlign: "center" }}>
                    {t.translate("Attachments")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {ticketData.attachments?.map((attachment: any, index: any) => {
                  if (attachment?.filename) {
                    return (
                      <tr key={attachment.id}>
                        <td style={{ textAlign: "center" }}>{attachment.id}</td>
                        <td style={{ textAlign: "center" }}>
                          <a
                            href={attachment.drive_id.includes("https://")?attachment.drive_id:`https://drive.google.com/uc?id=${attachment.drive_id}&export=download`}
                            style={{ color: "blue" }}
                          >
                            {" "}
                            {attachment.filename}
                          </a>
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          </div>
        </CardBody>
      </Card>
      <CardTitle
        style={{
          backgroundColor: "#3278bd",
          textAlign: "center",
          color: "white",
          fontSize: "20px",
        }}
      >
        {t.translate("Comments")}
      </CardTitle>
      <Card
        style={{
          backgroundColor: "lightgrey",
          maxHeight: "100vh",
          overflow: "auto",
        }}
      >
        <ChatBox>
          {comments?.map((c: any) => {
            if (c.role === "1" || c.role === "2" || c.role === "4") {
              return (
                <ReceiverMessage avatar>
                  <p style={{ textAlign: "start" }}>{c.displayname}</p>
                  <div
                    style={{
                      textAlign: "center",
                      border: "1px solid",
                      padding: "2%",
                    }}
                  >
                    {sectionContent(`${c.content}`)}
                  </div>
                  <p style={{ textAlign: "end" }}>{c.date}</p>
                </ReceiverMessage>
              );
            } else {
              return (
                <SenderMessage avatar>
                  <p style={{ textAlign: "end" }}>{c.displayname}</p>
                  <div
                    style={{
                      textAlign: "center",
                      border: "1px solid",
                      padding: "2%",
                    }}
                  >
                    {sectionContent(`${c.content}`)}
                  </div>
                  <p style={{ textAlign: "start" }}>{c.date}</p>
                </SenderMessage>
              );
            }
          })}
        </ChatBox>
      </Card>
      <div style={{ margin: "2%" }}>
        <button
          className="btn btn-primary"
          style={{ marginTop: "5%" }}
          onClick={handleAddOpenFile}
        >
          {t.translate("Add Comment")}
        </button>
      </div>
      <Modal isOpen={modal}>
        <ModalHeader>{t.translate("Add Comment")}</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <label>{t.translate("Description")}</label>
            <SunEditor
              setContents={commentData.content}
              onChange={handleChange}
            />
            <Input
              className="my-3 btn-primary"
              type="submit"
              value={t.translate("Submit")}
              style={{ backgroundColor: "blue" }}
              disabled={show}
            />
            {show && <div className="text-center">{progress}%</div>}
            {show && <Progress value={progress} />}
          </Form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={() => setModal(false)}>
            {t.translate("Cancel")}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ViewDepartmentTicket;
